<i18n src="./translations"></i18n>

<template>
  <ul class="documents-list">
    <li v-for="(document, index) in documents" :key="index">
      <a
        :href="document.url"
        :aria-label="`${$t('documents-list.label')}: ${document.title}`"
        target="_blank"
        rel="noopener noreferrer"
        :title="document.title"
        data-testid="document-link"
      >
        <Icon
          :aria-label="$t('documents-list.icon')"
          name="NewDocumentPdf"
          height="50"
          width="50"
        />
        <span class="text">{{ document.title }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import Icon from 'Components/00-generated/Icon';

export default {
  name: 'DocumentsList',
  components: { Icon },
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.documents-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-2);

  li a {
    display: flex;
    align-items: center;
    flex-direction: column;
    color: var(--color-kfzteile24-secondary);
    gap: var(--space-1);
    max-width: 100px;
    text-align: center;

    .text {
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: var(--font-size-SM);
    }

    &:hover {
      .text {
        text-decoration: underline;
      }
    }
  }
}
</style>
